import type { RouteLocationRaw } from 'vue-router'

import type { CurtainLoginState, LoginFormType } from '@/types/ui'
import { UserRoleCodes } from '@/types'

export const DEFAULT_LOGIN_FORM: LoginFormType = {
  email: '',
  password: '',
}

export const USER_ROLES: { name: string; code: UserRoleCodes }[] = [
  { name: 'Администратор', code: UserRoleCodes.Administrator },
  { name: 'Контент-менеджер', code: UserRoleCodes.Manager },
  { name: 'Продавец-консультант', code: UserRoleCodes.Salesman },
]

export const ROLES_REDIRECT_PAGES: Partial<
  Record<UserRoleCodes, RouteLocationRaw>
> = {
  [UserRoleCodes.Administrator]: { name: 'manager-blocks' },
  [UserRoleCodes.Manager]: { name: 'manager-blocks' },
  [UserRoleCodes.Salesman]: { name: 'manager-orders' },
}

export const CURTAIN_LOGIN_DEFAULT_STATE: CurtainLoginState = {
  checkout: false,
  tab: 'sms',
}

export const CURTAIN_LOGIN_TITLES: Record<CurtainLoginState['tab'], string> = {
  beforeCheckout: 'Персональная скидка',
  sms: 'Войти / зарегистрироваться',
  confirm: 'Подтвердите номер',
}
